import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import { Input } from '@getro/rombo';
import Filter from 'components/molecules/Filter';
import { ROLE_OPTIONS, CONTACTS_OPTIONS, LINKEDIN_OPTIONS, INVITE_STATUS_OPTIONS } from '../hooks/useFilteredAdmins';

const optionFor = (options, value) => options.find((option) => option.value === value) || options[0];

const TeamMembersFilters = ({ filters, onChange, isCustomer }) => (
  <Flex mb="16px" alignItems="flex-end" sx={{ gap: '8px', flexWrap: 'wrap' }} data-testid="team-members-filters">
    <Box width="280px">
      <Input
        size="small"
        variant="search"
        type="text"
        value={filters.search}
        placeholder="Search by name or email"
        onChange={(e) => onChange('search', e.target.value)}
        data-testid="team-members-search"
      />
    </Box>
    <Box width="160px">
      <Filter
        name="inviteStatus"
        showLabel={false}
        size="small"
        isSearchable={false}
        options={INVITE_STATUS_OPTIONS}
        value={optionFor(INVITE_STATUS_OPTIONS, filters.inviteStatus)}
        onChange={(option) => onChange('inviteStatus', option.value)}
      />
    </Box>
    {isCustomer && (
      <>
        <Box width="120px">
          <Filter
            name="role"
            showLabel={false}
            size="small"
            isSearchable={false}
            options={ROLE_OPTIONS}
            value={optionFor(ROLE_OPTIONS, filters.role)}
            onChange={(option) => onChange('role', option.value)}
          />
        </Box>
        <Box width="200px">
          <Filter
            name="contactsShared"
            showLabel={false}
            size="small"
            isSearchable={false}
            options={CONTACTS_OPTIONS}
            value={optionFor(CONTACTS_OPTIONS, filters.contactsShared)}
            onChange={(option) => onChange('contactsShared', option.value)}
          />
        </Box>
        <Box width="200px">
          <Filter
            name="linkedin"
            showLabel={false}
            size="small"
            isSearchable={false}
            options={LINKEDIN_OPTIONS}
            value={optionFor(LINKEDIN_OPTIONS, filters.linkedin)}
            onChange={(option) => onChange('linkedin', option.value)}
          />
        </Box>
      </>
    )}
  </Flex>
);

TeamMembersFilters.propTypes = {
  filters: PropTypes.shape({
    search: PropTypes.string,
    inviteStatus: PropTypes.string,
    role: PropTypes.string,
    contactsShared: PropTypes.string,
    linkedin: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  isCustomer: PropTypes.bool,
};

TeamMembersFilters.defaultProps = {
  isCustomer: false,
};

export default TeamMembersFilters;
